import styled, { css } from 'styled-components'

import Media from 'builder/styles/media'
import Sizes from 'builder/styles/sizes'
import Colors from 'builder/styles/colors'
import Typography, { FontWeights } from 'builder/styles/typography'

import Icon24 from 'builder/components/Icon'
import Spinner from 'builder/components/Spinner'
import ModalOverlay from 'builder/components/ModalOverlay'
import AutoApplyImage from './assets/auto-apply.png'
import ResumeDistributionImage from './assets/resume-distribution.png'

export const Modal = styled(ModalOverlay).attrs({
  fullScreen: true,
  backgroundOpacity: 1,
  background: Colors.White,
  overlayFadeDuration: 350,
  contentSlideDuration: 350,
})``

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
`

export const HeaderMenu = styled.div`
  height: 80px;
  padding: 0 28px 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: ${Colors.White};
  z-index: 2;
`

export const CloseButton = styled(Icon24.CloseBig)`
  cursor: pointer;
  color: ${Colors.Neutral40};
`

export const ModalContainer = styled.div`
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  padding-bottom: 28px;
  gap: 32px;

  ${Media.Phone`
    gap: 24px;
    padding: 0 20px;
  `}
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

export const Header = styled.h1`
  text-align: center;
  color: ${Colors.Neutral90};

  ${Typography.M}
  ${FontWeights.Medium}
`

export const SubHeader = styled.p`
  color: ${Colors.Neutral90};
  ${Typography.Body}
  ${FontWeights.Regular}
`

export const CardContainer = styled.div`
  gap: 24px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${Media.Tablet`
    gap: 16px;
    flex-direction: column;
  `}
`

export const Card = styled.div`
  width: 482px;
  border-radius: 12px;
  position: relative;

  ${Media.Phone`
    width: 100%;
    max-width: 482px;
  `}
`

export const CardHeader = styled.div<{ $backgroundColor: string }>`
  width: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: space-between;
  padding: 10px ${Sizes.M} 50px;
  border-radius: 12px 12px 0 0;
  background: ${props => props.$backgroundColor};
`

export const CardHeaderText = styled.div<{ $textColor: string }>`
  ${Typography.S}
  ${FontWeights.Medium}

  color: ${props => props.$textColor};
`

export const CardHeaderIcon = styled.div<{ $isResume?: boolean }>`
  width: 32px;
  height: 57px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${AutoApplyImage});

  ${({ $isResume }) =>
    $isResume &&
    css`
      width: 42px;
      background-image: url(${ResumeDistributionImage});
    `}
`

export const CardBody = styled.div`
  margin-top: 76px;
  height: 396px;
  position: relative;
  z-index: 1;

  ${Media.Phone`
    margin-top: 78px;
    height: auto;
  `}
`

export const ActionContainer = styled.div`
  gap: 16px;
  display: flex;
  justify-content: center;
  position: sticky;
  bottom: 0;
  margin-top: auto;
  z-index: 2;

  ${Media.Tablet`
    padding: 16px 0;
    background: ${Colors.White};
  `}
`

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const PriceLoader = styled(Spinner)`
  width: 20px;
  height: 20px;
`

export const SlashedPrice = styled.span`
  color: #92cdfc;
  text-decoration: line-through;
`
